/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ReferencedOrganisationDTO } from './ReferencedOrganisationDTO';
import {
    ReferencedOrganisationDTOFromJSON,
    ReferencedOrganisationDTOFromJSONTyped,
    ReferencedOrganisationDTOToJSON,
    ReferencedOrganisationDTOToJSONTyped,
} from './ReferencedOrganisationDTO';

/**
 * 
 * @export
 * @interface WorkOrganisationDTO
 */
export interface WorkOrganisationDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkOrganisationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrganisationDTO
     */
    role?: string;
    /**
     * 
     * @type {ReferencedOrganisationDTO}
     * @memberof WorkOrganisationDTO
     */
    organisation?: ReferencedOrganisationDTO;
}

/**
 * Check if a given object implements the WorkOrganisationDTO interface.
 */
export function instanceOfWorkOrganisationDTO(value: object): value is WorkOrganisationDTO {
    return true;
}

export function WorkOrganisationDTOFromJSON(json: any): WorkOrganisationDTO {
    return WorkOrganisationDTOFromJSONTyped(json, false);
}

export function WorkOrganisationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrganisationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'role': json['role'] == null ? undefined : json['role'],
                  'organisation': json['organisation'] == null ? undefined : ReferencedOrganisationDTOFromJSON(json['organisation']),
    };
}

export function WorkOrganisationDTOToJSON(json: any): WorkOrganisationDTO {
    return WorkOrganisationDTOToJSONTyped(json, false);
}

export function WorkOrganisationDTOToJSONTyped(value?: WorkOrganisationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'role': value['role'],
        'organisation': ReferencedOrganisationDTOToJSON(value['organisation']),
    };
}


